import { Headphones } from "lucide-react";

export default function HeadphonesCheck({ onConfirm, onBack }) {
  return (
    <div className="bg-[#111827] border border-[#1E2D3D] rounded-2xl p-6 sm:p-8 max-w-xl mx-auto">
      <div className="text-center mb-8">
        <div className="w-20 h-20 bg-[#60A5FA]/10 rounded-full flex items-center justify-center mx-auto mb-6 headphones-pulse">
          <Headphones className="w-10 h-10 text-[#60A5FA]" />
        </div>

        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#60A5FA] mb-3">
          Equipment Required
        </p>

        <h2 className="text-2xl sm:text-3xl font-medium text-[#F8FAFC] mb-4 font-['Outfit']">
          You'll need headphones to take this test
        </h2>

        <p className="text-[#94A3B8] max-w-md mx-auto">
          For accurate results, please use quality headphones. Earbuds or over-ear
          headphones work best.
        </p>
      </div>

      <div className="bg-[#1E293B] rounded-xl p-4 mb-8">
        <p className="text-[#94A3B8] text-sm font-medium mb-3">
          Compatible headphones include:
        </p>
        <div className="flex flex-wrap gap-2">
          {["AirPods", "Samsung", "Bose", "Sony", "Beats", "JBL", "Anker"].map(
            (brand) => (
              <span
                key={brand}
                className="px-3 py-1 bg-[#111827] rounded-full text-[#64748B] text-sm"
              >
                {brand}
              </span>
            )
          )}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <button
          onClick={onConfirm}
          className="w-full py-4 px-6 bg-[#22D3EE] text-[#0A0F1C] font-semibold rounded-lg hover:bg-[#67E8F9] transition-all flex items-center justify-center gap-2"
          data-testid="headphones-confirm-btn"
        >
          <Headphones className="w-5 h-5" />
          I'm Wearing Headphones
        </button>

        <button
          onClick={onBack}
          className="w-full py-3 px-6 rounded-lg border border-[#334155] text-[#94A3B8] font-medium hover:bg-[#1E293B] hover:text-[#F8FAFC] transition-colors flex items-center justify-center gap-2"
          data-testid="headphones-back-btn"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
      </div>
    </div>
  );
}
